import {
  GET_MANAGER_INFO,
  LOAD_MANAGER_INFO,
  COOLDOWN_MANAGER_INFO,
} from "../actions/types";

const initialState = {
  managerInfo: null,
  loading: false,
  resourceInfo: null,
  coolDown: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MANAGER_INFO:
      return {
        ...state,
        managerInfo: action.payload?.managerInfo
          ? action.payload.managerInfo
          : state.managerInfo,
        resourceInfo: action.payload.resourceInfo,
        loading: false,
      };
    case LOAD_MANAGER_INFO:
      if (action.payload === true) {
        return {
          ...state,
          loading: action.payload,
          managerInfo: {},
          resourceInfo: {},
        };
      } else {
        return {
          ...state,
          loading: action.payload,
        };
      }
    case COOLDOWN_MANAGER_INFO:
      return {
        ...state,
        coolDown: action.payload,
      };
    default:
      return state;
  }
}
